















import { Vue, Component, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import { EAfterSignStep } from '@signing-page/signing/types/enums/after-sign-step.ts';
import LoaderCircluar from '@/components/LoaderCircular.vue';
import { isWindowSize } from '@/helpers/window-size.helper';
import { EWindowSize } from '@/enums/window-size';
import { isPopupBlocked } from '@signing-page/common/utils/window';

@Component({
  components: {
    Button,
    LoaderCircluar,
  },
  data: () => ({
    EAfterSignStep,
  }),
})
export default class AfterSignCreateSignupComplete extends Vue {
  @Prop() redirectUrl: string;

  isSmallScreen = false;
  url = '';
  isPopupBlocked = false;
  redirectTimeout = 3000;

  handleClose() {
    this.$emit('close');
  }

  get showLoader(): boolean {
    return this.isSmallScreen && !this.isPopupBlocked;
  }

  mounted() {
    this.isSmallScreen = isWindowSize(EWindowSize.XSmall);
    if (!this.isSmallScreen) {
      const { href, pathname } = window.location;
      this.url = href.replace(pathname, `/${this.redirectUrl}`);

      setTimeout(() => {
        const newWindow: Window = window.open(this.url, '_blank');
        this.isPopupBlocked = isPopupBlocked(newWindow);
      }, this.redirectTimeout);
    }
  }
}
